module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-pagination', {
    attrs: {
      "total": 200,
      "current": _vm.current,
      "per-page": 10
    },
    on: {
      "update:current": function($event) {
        _vm.current = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "id": ("page" + (props.page.number)),
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                " + _vm._s(_vm.convertToRoman(props.page.number)) + "\n            ")])
      }
    }, {
      key: "previous",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                Previous\n            ")])
      }
    }, {
      key: "next",
      fn: function(props) {
        return _c('b-pagination-button', {
          attrs: {
            "page": props.page,
            "tag": "router-link",
            "to": ("/documentation/pagination#page" + (props.page.number))
          }
        }, [_vm._v("\n                Next\n            ")])
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51898654"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/pagination/examples/ExSlot.vue
// module id = 1147
// module chunks = 37 110